// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "asset_service".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "asset_service" table (1:1 with a DB row, on the wire). */
export const assetServiceAtomSchema = z.object({
    id: z.string(),
    assetId: z.string(),
    serviceId: z.string(),
    confidence: z.number().nullable(),
    isAutoGenerated: z.boolean(),
    depictsService: z.boolean().nullable(),
    depictsCheckedAt: z.string().datetime().nullable(),
    lastUsedAt: z.string().datetime().nullable(),
    useCount: z.number(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=assetService.js.map